exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-efc8f{padding:8px 12px;border-radius:8px}", ""]);

// Exports
exports.locals = {
	"input": "input-efc8f"
};